/**
 * Inline star rating — tiny presentational helper used by GbpCard + LocalCompetitorsCard.
 */
import React from "react";
import { Star } from "lucide-react";

export default function Stars({ value }) {
  if (value == null) return <span className="text-[#a0aec0] font-mono-tight">—</span>;
  return (
    <span className="inline-flex items-center gap-1 font-mono-tight text-[#1a202c]">
      <Star className="h-3 w-3 fill-[#f6ad55] text-[#f6ad55]" />
      {Number(value).toFixed(1)}
    </span>
  );
}
